var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('SjPaginationTable',{attrs:{"async":"","fullContainer":"","data":_vm.data,"columns":_vm.columns,"total":100},on:{"getData":_vm.handleGetData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }